// Recently viewed products
import { initSlider, vndHlp } from "//koboldnest.de/cdn/shop/t/4/assets/theme.js?v=58130512527112876771708700580";

class vndPrdRcnt extends HTMLElement {
  constructor() {
    super();
    this.addProduct();

    let rv = vndHlp.readCookie('vnd_recent_products');
    if (!rv) {
      this.style.display = 'none';
      return;
    }

    const el = this.querySelector('.recently-view-wrapper');
    const limit = parseInt(el.dataset.numlimit);
    const col = el.dataset.numcol;
    const $cl = this.querySelector('.items-carousel');
    let flkt = false;

    rv = rv.split(",");

    if ($cl) {
      flkt = initSlider($cl);
    }

    $.each(rv, function(i, e) {
      if (i > limit) return;

      if (e) {
        $.ajax({
          url: '/products/' + e + '?view=recent',
          dataType: "html",
          type: "GET",
          success: function(html) {
            const item = document.createElement("div");
            item.className = "products-matrix col-padding grid-items__" + col;
            item.innerHTML = html;
            if ( flkt ) {
              flkt.append(item);
            } else {
              el.appendChild(item);
            }
          }
        });
      }
    });
  }

  addProduct() {
    const $json = document.querySelector('.product-main [data-product-json]');
    if ($json) {
      const product = JSON.parse($json.innerHTML);
      let rv = vndHlp.readCookie('vnd_recent_products') || "";
      const handle = product.handle;
      rv = rv.split(",");
      if ( $.inArray(handle, rv) !== -1 ) {
        rv = $.grep(rv, function(value) {
          return value != handle;
        });
      }
      rv.unshift(handle);
      if (rv.length > 30) {
        rv.pop();
      }
      vndHlp.createCookie('vnd_recent_products', rv.join(), 1);
    }
  }
}
customElements.define('recent-products', vndPrdRcnt);
